var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9217 3.86998C27.7661 3.29168 27.454 2.76357 27.0175 2.33962C26.5809 1.91568 26.0354 1.61109 25.4368 1.45698C21.8074 1.04421 18.1542 0.858209 14.4999 0.900132C10.8456 0.858209 7.19232 1.04421 3.56294 1.45698C2.96432 1.61109 2.41886 1.91568 1.98228 2.33962C1.54571 2.76357 1.23368 3.29168 1.07806 3.86998C0.6805 6.01966 0.487208 8.19984 0.500593 10.3834C0.486538 12.5782 0.679827 14.7696 1.07806 16.9306C1.24174 17.4995 1.55736 18.0171 1.9934 18.4317C2.42944 18.8462 2.97063 19.1432 3.56294 19.2929C7.19232 19.7057 10.8456 19.8917 14.4999 19.8498C18.1542 19.8917 21.8074 19.7057 25.4368 19.2929C26.0291 19.1432 26.5703 18.8462 27.0064 18.4317C27.4424 18.0171 27.758 17.4995 27.9217 16.9306C28.3199 14.7696 28.5132 12.5782 28.4992 10.3834C28.5125 8.19984 28.3193 6.01966 27.9217 3.86998ZM11.63 14.4163V6.38423L18.9622 10.3834L11.63 14.3994V14.4163Z",
    fill: "#FF3D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.038c0eaa6ca04f3ba75f3b46009e5d5a.svg";
export { ForwardRef as ReactComponent };